import { z } from 'zod';

import type {
  PurchaseReceiptGetRequest,
  PurchaseReceiptGetResponse,
  PurchasesHistoryListRequest,
  PurchasesHistoryListResponse,
} from './purchases-reporting.dto.js';
import {
  PrintStatusSchema,
  PurchaseCancellationSchema,
  PurchaseCommittedSnapshotSchema,
  PurchaseHistoryItemSchema,
} from './purchases.schema.js';

const timestampSchema = z.iso.datetime();
const identifierValueSchema = z.string().trim().min(1).max(64);

export const PurchasesHistoryListRequestSchema: z.ZodType<PurchasesHistoryListRequest> = z.object({
  companyId: z.uuid(),
  from: timestampSchema,
  to: timestampSchema,
  stationId: z.uuid().optional(),
  identifier: identifierValueSchema.optional(),
  minPayout: z.number().min(0).optional(),
});

export const PurchasesHistoryListResponseSchema: z.ZodType<PurchasesHistoryListResponse> = z.object({
  items: z.array(PurchaseHistoryItemSchema),
});

export const PurchaseReceiptGetRequestSchema: z.ZodType<PurchaseReceiptGetRequest> = z.object({
  companyId: z.uuid(),
  purchaseId: z.uuid(),
});

export const PurchaseReceiptGetResponseSchema: z.ZodType<PurchaseReceiptGetResponse> = z.object({
  purchase: PurchaseCommittedSnapshotSchema,
  printStatus: PrintStatusSchema,
  cancellation: PurchaseCancellationSchema.nullable(),
});
